import React from 'react';

export default function CustomTooltip({ active, payload, label }) {
  if (!active || !payload || !payload.length) return null;

  const MAX_ITEMS_PER_COLUMN = 5;
  
  const totalItems = payload.length;
  const numColumns = Math.min(
    Math.ceil(totalItems / MAX_ITEMS_PER_COLUMN),
    Math.ceil(totalItems / 2)
  );
  
  const itemsPerColumn = Math.ceil(totalItems / numColumns);
  
  const columns = [];
  for (let i = 0; i < numColumns; i++) {
    const start = i * itemsPerColumn;
    const end = start + itemsPerColumn;
    columns.push(payload.slice(start, end));
  }

  // Format numbers with thousand separators
  const formatValue = (value) => {
    if (typeof value === 'number') {
      return value.toLocaleString('en-US');
    }
    return value;
  };

  return (
    <div style={{
      backgroundColor: 'rgba(255, 255, 255, 0.98)',
      border: '1px solid #e5e7eb',
      borderRadius: '8px',
      padding: '8px 12px',
      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
      minWidth: numColumns === 1 ? '180px' : `${numColumns * 140}px`,
      maxWidth: '600px'
    }}>
      <p style={{ 
        fontWeight: 600, 
        marginBottom: '6px',
        color: '#1e293b',
        fontSize: '14px',
        borderBottom: '1px solid #e5e7eb',
        paddingBottom: '4px'
      }}>
        {label}
      </p>
      
      <div style={{ 
        display: 'grid', 
        gridTemplateColumns: `repeat(${numColumns}, 1fr)`,
        gap: '8px 16px'
      }}>
        {columns.map((column, colIndex) => (
          <div key={colIndex}>
            {column.map((entry, index) => (
              <div key={index} style={{ 
                margin: '3px 0',
                fontSize: '13px',
                display: 'flex',
                alignItems: 'center',
                gap: '6px'
              }}>
                <span style={{
                  display: 'inline-block',
                  width: '10px',
                  height: '10px',
                  backgroundColor: entry.color,
                  borderRadius: '2px',
                  flexShrink: 0
                }} />
                <span style={{ 
                  color: '#64748b', 
                  flex: 1,
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap'
                }}>
                  {entry.name}:
                </span>
                <span style={{ 
                  fontWeight: 600, 
                  color: '#1e293b',
                  flexShrink: 0
                }}>
                  {formatValue(entry.value)}
                </span>
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}